var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRush(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "29px",
    viewBox: "0 0 29 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons / play entry / rush") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons-/-play-entry-/-rush",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.27854688,0.142070921 C12.2499102,0.166480977 18.2345352,2.17762934 22.2324218,6.17551602 C26.1394473,10.0825414 28.1490147,15.8870249 28.261124,23.5889664 L28.2658872,24.1293898 C28.2724279,26.2715757 26.5938224,28.0256082 24.4777591,28.1361144 L24.2536369,28.1416211 C16.2822736,28.117211 10.2976486,26.1060626 6.29976191,22.108176 C2.39273649,18.2011505 0.383169108,12.396667 0.271059778,4.69472552 L0.266296597,4.15430214 C0.259755865,2.01211623 1.93836141,0.258083783 4.05442468,0.147577552 L4.27854688,0.142070921 Z M4.27548468,1.14206623 L4.25711138,1.14206623 C2.65943742,1.1469587 1.35728756,2.39987246 1.27083361,3.96982732 L1.26627723,4.14552414 L1.27095386,4.68017108 C1.37955619,12.1411813 3.30315734,17.6973578 7.0068687,21.4010692 C10.7093807,25.1035812 16.263907,27.0273629 23.7179725,27.1368841 L24.2750724,27.1416257 C25.8727463,27.1367333 27.1748962,25.8838195 27.2613501,24.3138647 L27.2659065,24.1381678 L27.2612299,23.6035209 C27.1526276,16.1425107 25.2290264,10.5863342 21.5253151,6.8826228 C17.734648,3.09195577 12.0027256,1.16572873 4.27548468,1.14206623 Z",
    id: "Rectangle",
    fill: "#91ACCA",
    fillRule: "nonzero",
    transform: "translate(14.266092, 14.141846) rotate(90.000000) translate(-14.266092, -14.141846) "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line",
    fill: "#91ACCA",
    fillRule: "nonzero",
    transform: "translate(5.957573, 22.097101) rotate(45.000000) translate(-5.957573, -22.097101) ",
    points: "12.7075729 21.5971011 12.7075729 22.5971011 -0.792427096 22.5971011 -0.792427096 21.5971011"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line",
    fill: "#91ACCA",
    fillRule: "nonzero",
    transform: "translate(22.221029, 5.833645) rotate(45.000000) translate(-22.221029, -5.833645) ",
    points: "28.9710289 5.33364512 28.9710289 6.33364512 15.4710289 6.33364512 15.4710289 5.33364512"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line",
    fill: "#91ACCA",
    fillRule: "nonzero",
    transform: "translate(7.548563, 20.859664) rotate(45.000000) translate(-7.548563, -20.859664) ",
    points: "15.5485632 20.3596642 15.5485632 21.3596642 -0.451436838 21.3596642 -0.451436838 20.3596642"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8748348,10.636946 C20.1509772,10.636946 20.3748348,10.8608036 20.3748348,11.136946 C20.3748348,11.3824059 20.1979596,11.5865543 19.9647104,11.6288903 L19.8748348,11.636946 L15.3748348,11.636946 C15.0986924,11.636946 14.8748348,11.4130884 14.8748348,11.136946 C14.8748348,10.8914861 15.05171,10.6873376 15.2849592,10.6450016 L15.3748348,10.636946 L19.8748348,10.636946 Z",
    id: "Line",
    fill: "#91ACCA",
    fillRule: "nonzero",
    transform: "translate(17.624835, 11.136946) rotate(45.000000) translate(-17.624835, -11.136946) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7535145,12.7582663 C18.0296568,12.7582663 18.2535145,12.9821239 18.2535145,13.2582663 C18.2535145,13.5037262 18.0766393,13.7078747 17.8433901,13.7502106 L17.7535145,13.7582663 L13.2535145,13.7582663 C12.9773721,13.7582663 12.7535145,13.5344087 12.7535145,13.2582663 C12.7535145,13.0128064 12.9303896,12.8086579 13.1636388,12.766322 L13.2535145,12.7582663 L17.7535145,12.7582663 Z",
    id: "Line",
    fill: "#91ACCA",
    fillRule: "nonzero",
    transform: "translate(15.503514, 13.258266) rotate(45.000000) translate(-15.503514, -13.258266) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6321941,14.8795867 C15.9083365,14.8795867 16.1321941,15.1034443 16.1321941,15.3795867 C16.1321941,15.6250466 15.9553189,15.829195 15.7220697,15.871531 L15.6321941,15.8795867 L11.1321941,15.8795867 C10.8560517,15.8795867 10.6321941,15.655729 10.6321941,15.3795867 C10.6321941,15.1341268 10.8090693,14.9299783 11.0423185,14.8876423 L11.1321941,14.8795867 L15.6321941,14.8795867 Z",
    id: "Line",
    fill: "#91ACCA",
    fillRule: "nonzero",
    transform: "translate(13.382194, 15.379587) rotate(45.000000) translate(-13.382194, -15.379587) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5108738,17.000907 C13.7870161,17.000907 14.0108738,17.2247646 14.0108738,17.500907 C14.0108738,17.7463669 13.8339986,17.9505154 13.6007494,17.9928513 L13.5108738,18.000907 L9.01087376,18.000907 C8.73473139,18.000907 8.51087376,17.7770494 8.51087376,17.500907 C8.51087376,17.2554471 8.68774892,17.0512986 8.92099813,17.0089627 L9.01087376,17.000907 L13.5108738,17.000907 Z",
    id: "Line",
    fill: "#91ACCA",
    fillRule: "nonzero",
    transform: "translate(11.260874, 17.500907) rotate(45.000000) translate(-11.260874, -17.500907) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1928543,13.8189265 C21.4689967,13.8189265 21.6928543,14.0427841 21.6928543,14.3189265 C21.6928543,14.5643864 21.5159791,14.7685349 21.2827299,14.8108708 L21.1928543,14.8189265 L7.69285428,14.8189265 C7.4167119,14.8189265 7.19285428,14.5950689 7.19285428,14.3189265 C7.19285428,14.0734666 7.36972944,13.8693181 7.60297865,13.8269822 L7.69285428,13.8189265 L21.1928543,13.8189265 Z",
    id: "Line",
    fill: "#91ACCA",
    fillRule: "nonzero",
    transform: "translate(14.442854, 14.318926) rotate(135.000000) translate(-14.442854, -14.318926) "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line",
    fill: "#91ACCA",
    fillRule: "nonzero",
    transform: "translate(20.983592, 7.424635) rotate(45.000000) translate(-20.983592, -7.424635) ",
    points: "28.983592 6.92463537 28.983592 7.92463537 12.983592 7.92463537 12.983592 6.92463537"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRush);
export default __webpack_public_path__ + "static/media/rush.e339f0254affe9157558d3e2b271d3a4.svg";
export { ForwardRef as ReactComponent };